import type { Flags } from '@fullstory/client-api';
import { PageModel } from '@fullstory/playback-model';
import { buildResourceMap, urlWithPlaybackContext } from '@fullstory/renderer-shared';
import { getPlaybackDomain } from '@fullstory/util/domains';
import { getResourceProxyDomain } from '@fullstory/util/domains';

export const getRendererURL = async (args: {
  flags: Flags;
  orgId: string;
  page: Readonly<PageModel>;
}) => {
  const { flags, orgId, page } = args;

  // We must be cross domain for this.
  const playbackDomain = getPlaybackDomain(window.location.host);
  const remoteRendererUrl = `https://${playbackDomain}/s/playback/fsrenderer.html`;
  const resourceDomain = getResourceProxyDomain(window.location.host);
  const resourceProxyPrefix = `${window.location.protocol}//${resourceDomain}/`;
  const rendererPageUrl = new URL(remoteRendererUrl, window.location.href);
  return urlWithPlaybackContext(rendererPageUrl, {
    flags: {
      client: flags.jsonFlags(),
      features: flags.featureFlags(),
    },
    page: {
      orgId,
      sessionId: page.sessionId,
      userId: page.userId,
      pageId: page.pageId,
      pageType: page.type || 'unknown',
      resourceProxyPrefix,
      gcsBucketPrefix: page.gcsBucketUrl,
      resourceMap: buildResourceMap(page.getRawPageDesc()),
      windowWidth: page.width ?? 0,
      windowHeight: page.height ?? 0,
      screenWidth: page.screenWidth ?? 0,
      screenHeight: page.screenHeight ?? 0,
    },
  });
};
